module.exports = __webpack_public_path__ + "img/nose.77aca364.svg";